// Module
var code = "<div layout=\"column\" class=\"full-height\"> <app-planning-default-drafts-table class=\"flex bringoz-table\" [drafts]=\"$ctrl.drafts\" (fetch-next-event)=\"$ctrl.fetchNext()\" (delete-draft)=\"$ctrl.onDeleteDraft($event)\"> </app-planning-default-drafts-table> </div> ";
// Exports
export default code;